export const NumberVa = val => {
    if (!/(^[1-9]\d*$)/.test(val)) {
        return ""
    }
    return val
}